import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import Button from "../../shared/button/Btn"
import { showModal } from '../../../features/modal/modalSlice'
import { cancelSignedInvoice } from '../../../features/e-Arsiv/eArsivSlice'
import InputTextarea from '../../shared/input/new/InputTextarea'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 40px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            margin-block: 20px;
            padding: 0 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 100%;
            gap: 30px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 40px;
            gap: 15px;
        }
    }
`

const CancelGibEarsivInvoiceModal = () => {
    const {theme} = useSelector((state)=> state.layout)
    const {selectedGibInvoice} = useSelector((state)=> state.eArsiv)
    const dispatch = useDispatch()
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

    const gibCallId = JSON.parse(storage.getItem("gibCallId"))
    const gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"))
    const gibToken = JSON.parse(storage.getItem("gibToken"))

    const [deleteNote, setDeleteNote] = useState("")

    const handleSubmit = () => {
        const addData = {
            "authInfoDto": {
                "token": gibToken,
                "callId": gibCallId,
                "callIdCount": gibCallIdCount
            },
            "uuid": selectedGibInvoice?.uuid,
            // "documentDate": selectedGibInvoice?.documentDate?.split("-")?.join("/") ,
            "deleteNote": deleteNote
        }
        dispatch(cancelSignedInvoice(addData))
    }

  return (
    <ModalContainer onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className='modal'>
            <div className="content">
                <h3>Neden Silmek İstiyorsunuz?</h3>
                <InputTextarea labelText='Silme Nedeni' data={deleteNote} setData={(e) => setDeleteNote(e.target.value)} inputWidth={"400px"} />
                <div className="button-grp">
                    <Button width="150px" color="#E85446" padding="10px" handleClick={handleSubmit} >Gönder</Button>
                    <Button handleClick={()=>dispatch(showModal(null))} width="150px" color="#E85446" padding="10px">Kapat</Button>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}

export default CancelGibEarsivInvoiceModal